/* eslint-disable */
import { Check } from 'lucide-react';
const inlineDefaultClasses = {
    container: 'flex items-center justify-center w-full',
    step: 'flex items-center',
    circleBase: 'w-7 h-7 rounded-full flex items-center justify-center text-[13px] font-semibold flex-shrink-0 transition-all duration-300',
    circleCompleted: 'bg-green-500 text-white',
    circleActive: 'bg-amber-400 text-black',
    circleUpcoming: 'bg-gray-200 text-gray-500',
    labelWrap: 'flex flex-col items-start leading-tight ml-2.5',
    title: 'text-[13px] font-semibold',
    titleReached: 'text-gray-800',
    titleUpcoming: 'text-gray-400',
    subtitle: 'text-[11px] text-gray-400 font-normal',
    connector: 'w-16 h-[2px] mx-4 bg-gray-200 transition-all duration-300',
    connectorCompleted: 'bg-green-500',
};

function Stepper(props) {
    const {
        steps = [],
        currentStep = 1,
        variant = 'default',
        classes = {},
    } = props;

    if (variant === 'inline') {
        const c = { ...inlineDefaultClasses, ...classes };
        return (
            <div className={c.container}>
                {steps.map((step, index) => {
                    const stepNo = index + 1;
                    const isActive = stepNo === currentStep;
                    const isCompleted = stepNo < currentStep;
                    return (
                        <div key={index} className={c.step}>
                            <span
                                className={`${c.circleBase} ${isCompleted
                                    ? c.circleCompleted
                                    : isActive
                                        ? c.circleActive
                                        : c.circleUpcoming}`}
                            >
                                {isCompleted ? <Check size={15} strokeWidth={3} /> : stepNo}
                            </span>
                            <div className={c.labelWrap}>
                                <span className={`${c.title} ${(isActive || isCompleted) ? c.titleReached : c.titleUpcoming}`}>
                                    {step?.title}
                                </span>
                                {step?.subtitle && (
                                    <span className={c.subtitle}>{step?.subtitle}</span>
                                )}
                            </div>
                            {index < steps.length - 1 && (
                                <span className={`${c.connector} ${isCompleted ? c.connectorCompleted : ''}`} />
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }

    return (
        <div className='relative flex items-center justify-between w-full max-w-2xl mx-auto'>
            {/* Continuous background line behind all circles */}
            <div
                className='absolute h-[3px] bg-gray-300'
                style={{
                    top: '12px',
                    left: '50px',
                    right: '50px',
                    zIndex: 0
                }}
            />

            {/* Progress line - filled portion */}
            <div
                className='absolute h-[3px] bg-teal-600 transition-all duration-500'
                style={{
                    top: '12px',
                    left: '50px',
                    width: steps.length > 1
                        ? `calc(${((currentStep - 1) / (steps.length - 1)) * 100}% - 100px * ${(currentStep - 1) / (steps.length - 1)})`
                        : '0%',
                    zIndex: 1
                }}
            />

            {/* Steps */}
            {steps.map((step, index) => {
                const isActive = (index + 1) === currentStep;
                const isCompleted = (index + 1) < currentStep;

                return (
                    <div key={index} className='flex flex-col items-center relative' style={{ zIndex: 2 }}>
                        <div
                            className={`
                                w-6 h-6 rounded-full border-[3px] flex items-center justify-center
                                transition-all duration-300
                                ${isCompleted
                                    ? 'bg-teal-600 border-teal-600'
                                    : isActive
                                        ? 'bg-white border-teal-600'
                                        : 'bg-white border-gray-300'
                                }
                            `}
                        >
                            {isCompleted && <Check size={14} className='text-white' strokeWidth={3} />}
                        </div>

                        <div
                            className={`
                                mt-2 text-[12px] font-semibold whitespace-nowrap
                                ${isActive || isCompleted ? 'text-gray-800' : 'text-gray-400'}
                            `}
                        >
                            {step?.title}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default Stepper;
